export default __webpack_public_path__ + "static/media/jean.d5cb0a8b.png";